import { branch, compose, renderComponent, withProps } from 'recompose';
import { withResizeDetector } from 'react-resize-detector';
import Spinner from './Spinner';
import { withTranslationProvider } from './Translations';

const sizeSm = 576;
const sizeMd = 720;
const sizeLg = 992;
const sizeXl = 1200;

export const withResizeHelper = compose(
  withResizeDetector,
  withProps(({ width }) => {
    const isMobile = width <= sizeSm;
    let breakpoint = 'xs';
    if (width >= sizeXl) {
      breakpoint = 'xl';
    } else if (width >= sizeLg) {
      breakpoint = 'lg';
    } else if (width >= sizeMd) {
      breakpoint = 'md';
    } else if (width >= sizeSm) {
      breakpoint = 'sm';
    }
    return { isMobile, breakpoint };
  }),
);

export const withRedirectOnResize = (path = '/') => WrappedComponent => compose(
  withResizeHelper,
  withTranslationProvider,
  branch(
    ({ width }) => width === undefined,
    renderComponent(Spinner),
    branch(
      ({ isMobile = false }) => isMobile === false,
      () => ({ tRoute }) => {
        window.location = tRoute(path);
        return null;
      },
    ),
  ),
)(WrappedComponent);



// WEBPACK FOOTER //
// ./src/Common/ResizeHelper.js